module.exports = __webpack_public_path__ + "static/media/all_actors_icon.aa1a1b38.svg";